import { render, staticRenderFns } from "./OwalModal.vue?vue&type=template&id=2eea0ddd&scoped=true"
import script from "./OwalModal.vue?vue&type=script&lang=js"
export * from "./OwalModal.vue?vue&type=script&lang=js"
import style0 from "./OwalModal.vue?vue&type=style&index=0&id=2eea0ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea0ddd",
  null
  
)

export default component.exports